"use strict";


// ==========================================================
// RUTAS
// ==========================================================

const API_SALARIO_LISTAR =
    "/salario/listar";


// IMPORTANTE:
// NO SE UTILIZA /salario/empleados
//
// El backend tiene:
//
// router.get("/", ...)
//
// Por lo tanto:
//
// GET /salario

const API_SALARIO_EMPLEADOS =
    "/salario";


const API_SALARIO_INSERTAR =
    "/salario/insertar";


const API_SALARIO_ACTUALIZAR =
    "/salario/actualizar";


const API_SALARIO_ELIMINAR =
    "/salario/eliminar";


// ==========================================================
// VARIABLES
// ==========================================================

let salarios = [];

let empleados = [];

let cargandoEmpleados = false;

let guardandoSalario = false;

let actualizandoSalario = false;

let eliminandoSalario = false;


// ==========================================================
// INICIO
// ==========================================================

document.addEventListener(
    "DOMContentLoaded",
    async function () {

        console.log(
            "=========================================="
        );

        console.log(
            "SALARIO BASE"
        );

        console.log(
            "FRONTEND NODE.JS"
        );

        console.log(
            "=========================================="
        );


        establecerFechaActual();

        configurarEventos();


        // ==================================================
        // CARGAR DATOS
        // ==================================================

        await Promise.all([
            cargarSalarios(),
            cargarEmpleados()
        ]);

    }
);


// ==========================================================
// CONFIGURAR EVENTOS
// ==========================================================

function configurarEventos() {

    const btnNuevo =
        document.getElementById(
            "btnNuevoSalario"
        );


    if (btnNuevo) {

        btnNuevo.addEventListener(
            "click",
            abrirNuevoSalario
        );

    }


    const btnGuardar =
        document.getElementById(
            "btnGuardarSalario"
        );


    if (btnGuardar) {

        btnGuardar.addEventListener(
            "click",
            guardarSalario
        );

    }


    const btnActualizar =
        document.getElementById(
            "btnActualizarSalario"
        );


    if (btnActualizar) {

        btnActualizar.addEventListener(
            "click",
            actualizarSalario
        );

    }


    const selectEmpleado =
        document.getElementById(
            "idEmpleado"
        );


    if (selectEmpleado) {

        selectEmpleado.addEventListener(
            "change",
            seleccionarEmpleado
        );

    }


    const buscar =
        document.getElementById(
            "buscarSalario"
        );


    if (buscar) {

        buscar.addEventListener(
            "input",
            function () {

                filtrarSalarios(
                    this.value
                );

            }
        );

    }


    const limpiar =
        document.getElementById(
            "btnLimpiarBusqueda"
        );


    if (limpiar) {

        limpiar.addEventListener(
            "click",
            function () {

                if (buscar) {

                    buscar.value = "";

                }


                renderizarSalarios(
                    salarios
                );

            }
        );

    }

}


// ==========================================================
// ABRIR NUEVO SALARIO
// ==========================================================

function abrirNuevoSalario() {

    limpiarFormulario();


    const select =
        document.getElementById(
            "idEmpleado"
        );


    /*
     * Si todavía no se cargaron
     * los empleados, se intenta cargar.
     */

    if (
        !empleados ||
        empleados.length === 0
    ) {

        cargarEmpleados();

    }


    const modalElement =
        document.getElementById(
            "modalSalario"
        );


    if (!modalElement) {

        console.error(
            "No existe #modalSalario"
        );

        return;

    }


    const modal =
        bootstrap.Modal.getOrCreateInstance(
            modalElement
        );


    modal.show();


    if (select) {

        setTimeout(
            function () {

                select.focus();

            },
            300
        );

    }

}


// ==========================================================
// FECHA ACTUAL
// ==========================================================

function establecerFechaActual() {

    const campo =
        document.getElementById(
            "fechaSalario"
        );


    if (!campo) {

        return;

    }


    campo.value =
        obtenerFechaHoy();

}


// ==========================================================
// CARGAR EMPLEADOS
// ==========================================================

async function cargarEmpleados() {

    /*
     * Evitar dos peticiones simultáneas.
     */

    if (cargandoEmpleados) {

        return;

    }


    const select =
        document.getElementById(
            "idEmpleado"
        );


    if (!select) {

        console.warn(
            "No existe el select #idEmpleado"
        );

        return;

    }


    cargandoEmpleados = true;


    try {

        select.disabled = true;


        select.innerHTML = `
            <option value="">
                Cargando empleados...
            </option>
        `;


        console.log(
            "=========================================="
        );

        console.log(
            "CARGANDO EMPLEADOS PARA SALARIO"
        );

        console.log(
            "RUTA:",
            API_SALARIO_EMPLEADOS
        );

        console.log(
            "=========================================="
        );


        const respuesta =
            await fetch(
                API_SALARIO_EMPLEADOS,
                {
                    method: "GET",
                    headers: {
                        "Accept":
                            "application/json"
                    }
                }
            );


        const texto =
            await respuesta.text();


        console.log(
            "STATUS EMPLEADOS:",
            respuesta.status
        );


        console.log(
            "RESPUESTA RAW EMPLEADOS:",
            texto
        );


        let resultado;


        try {

            resultado =
                texto
                    ? JSON.parse(texto)
                    : {};

        }
        catch (error) {

            throw new Error(
                "Node.js no devolvió JSON al cargar los empleados.\n\n" +
                texto.substring(
                    0,
                    500
                )
            );

        }


        if (!respuesta.ok) {

            throw new Error(
                resultado.mensaje ||
                resultado.message ||
                resultado.error ||
                "Error HTTP " +
                respuesta.status
            );

        }


        let lista = [];


        if (
            resultado &&
            Array.isArray(
                resultado.data
            )
        ) {

            lista =
                resultado.data;

        }

        else if (
            resultado &&
            Array.isArray(
                resultado.empleados
            )
        ) {

            lista =
                resultado.empleados;

        }

        else if (
            resultado &&
            Array.isArray(
                resultado.registros
            )
        ) {

            lista =
                resultado.registros;

        }

        else if (
            Array.isArray(
                resultado
            )
        ) {

            lista =
                resultado;

        }


        console.log(
            "EMPLEADOS RECIBIDOS:",
            lista
        );


        // ==================================================
        // ELIMINAR DUPLICADOS
        // ==================================================

        const mapa =
            new Map();


        lista.forEach(
            function (empleado) {

                const id =
                    empleado.IDEMPLEADO ??
                    empleado.idEmpleado ??
                    empleado.id ??
                    "";


                if (
                    id !== "" &&
                    id !== null &&
                    id !== undefined
                ) {

                    mapa.set(
                        String(id),
                        empleado
                    );

                }

            }
        );


        empleados =
            Array.from(
                mapa.values()
            );


        // ==================================================
        // ORDENAR POR NOMBRE
        // ==================================================

        empleados.sort(
            function (a, b) {

                const nombreA =
                    String(
                        a.NOMBREEMPLEADO ??
                        a.nombreEmpleado ??
                        a.nombre ??
                        ""
                    );


                const nombreB =
                    String(
                        b.NOMBREEMPLEADO ??
                        b.nombreEmpleado ??
                        b.nombre ??
                        ""
                    );


                return nombreA.localeCompare(
                    nombreB,
                    "es",
                    {
                        sensitivity:
                            "base"
                    }
                );

            }
        );


        // ==================================================
        // LIMPIAR SELECT
        // ==================================================

        select.innerHTML = `
            <option value="">
                Seleccione un empleado
            </option>
        `;


        // ==================================================
        // SIN EMPLEADOS
        // ==================================================

        if (
            empleados.length === 0
        ) {

            select.innerHTML = `
                <option value="">
                    No hay empleados disponibles
                </option>
            `;

            select.disabled = true;


            console.warn(
                "NO HAY EMPLEADOS PARA EL DROPDOWN"
            );


            return;

        }


        // ==================================================
        // LLENAR SELECT
        // ==================================================

        empleados.forEach(
            function (empleado) {

                agregarEmpleadoSelect(
                    select,
                    empleado
                );

            }
        );


        select.disabled = false;


        console.log(
            "TOTAL EMPLEADOS EN DROPDOWN:",
            empleados.length
        );

    }
    catch (error) {

        console.error(
            "ERROR CARGANDO EMPLEADOS:",
            error
        );


        empleados = [];


        select.innerHTML = `
            <option value="">
                Error al cargar empleados
            </option>
        `;


        select.disabled = true;


        alert(
            "ERROR AL CARGAR EMPLEADOS:\n\n" +
            error.message
        );

    }
    finally {

        cargandoEmpleados = false;

    }

}


// ==========================================================
// AGREGAR EMPLEADO AL SELECT
// ==========================================================

function agregarEmpleadoSelect(
    select,
    empleado
) {

    const id =
        empleado.IDEMPLEADO ??
        empleado.idEmpleado ??
        empleado.id ??
        "";


    const nombre =
        empleado.NOMBREEMPLEADO ??
        empleado.nombreEmpleado ??
        empleado.nombre ??
        "";


    const dpi =
        empleado.DPI ??
        empleado.dpi ??
        "";


    const direccion =
        empleado.DIRECCION ??
        empleado.direccion ??
        "";


    const puesto =
        empleado.NOMBREPUESTO ??
        empleado.nombrePuesto ??
        empleado.puesto ??
        "";


    if (
        id === "" ||
        id === null ||
        id === undefined
    ) {

        return;

    }


    const option =
        document.createElement(
            "option"
        );


    option.value =
        id;


    option.textContent =
        nombre
            ? `${nombre} - ID ${id}`
            : `Empleado #${id}`;


    option.dataset.id =
        id;


    option.dataset.nombre =
        nombre;


    option.dataset.dpi =
        dpi;


    option.dataset.direccion =
        direccion;


    option.dataset.puesto =
        puesto;


    select.appendChild(
        option
    );

}


// ==========================================================
// SELECCIONAR EMPLEADO
// ==========================================================

function seleccionarEmpleado() {

    const select =
        document.getElementById(
            "idEmpleado"
        );


    if (!select) {

        return;

    }


    const idSeleccionado =
        select.value;


    if (!idSeleccionado) {

        limpiarDatosEmpleado();

        return;

    }


    /*
     * Se busca el empleado en memoria.
     * No se hace otra petición al servidor.
     */

    const empleado =
        empleados.find(
            function (item) {

                const id =
                    item.IDEMPLEADO ??
                    item.idEmpleado ??
                    item.id ??
                    "";


                return String(id) ===
                    String(idSeleccionado);

            }
        );


    if (!empleado) {

        limpiarDatosEmpleado();

        return;

    }


    const id =
        empleado.IDEMPLEADO ??
        empleado.idEmpleado ??
        "";


    const nombre =
        empleado.NOMBREEMPLEADO ??
        empleado.nombreEmpleado ??
        empleado.nombre ??
        "";


    const dpi =
        empleado.DPI ??
        empleado.dpi ??
        "";


    const direccion =
        empleado.DIRECCION ??
        empleado.direccion ??
        "";


    const puesto =
        empleado.NOMBREPUESTO ??
        empleado.nombrePuesto ??
        empleado.puesto ??
        "";


    establecerValor(
        "mostrarIdEmpleado",
        id
    );


    establecerValor(
        "nombreEmpleado",
        nombre
    );


    establecerValor(
        "dpiEmpleado",
        dpi
    );


    establecerValor(
        "direccionEmpleado",
        direccion
    );


    establecerValor(
        "puestoEmpleado",
        puesto
    );


    console.log(
        "EMPLEADO SELECCIONADO:",
        {
            IDEMPLEADO: id,
            NOMBREEMPLEADO: nombre,
            DPI: dpi,
            DIRECCION: direccion,
            NOMBREPUESTO: puesto
        }
    );

}


// ==========================================================
// LIMPIAR DATOS EMPLEADO
// ==========================================================

function limpiarDatosEmpleado() {

    const campos = [
        "mostrarIdEmpleado",
        "nombreEmpleado",
        "dpiEmpleado",
        "direccionEmpleado",
        "puestoEmpleado"
    ];


    campos.forEach(
        function (id) {

            const campo =
                document.getElementById(
                    id
                );


            if (campo) {

                campo.value = "";

            }

        }
    );

}


// ==========================================================
// CARGAR SALARIOS
// ==========================================================

async function cargarSalarios() {

    const tbody =
        document.getElementById(
            "tbodySalarios"
        );


    if (tbody) {

        tbody.innerHTML = `
            <tr>
                <td
                    colspan="9"
                    class="loading">

                    <div
                        class="spinner-border text-success me-2">
                    </div>

                    Cargando salarios...

                </td>
            </tr>
        `;

    }


    try {

        console.log(
            "SOLICITANDO:",
            API_SALARIO_LISTAR
        );


        const respuesta =
            await fetch(
                API_SALARIO_LISTAR,
                {
                    method: "GET",
                    headers: {
                        "Accept":
                            "application/json"
                    }
                }
            );


        const texto =
            await respuesta.text();


        console.log(
            "STATUS SALARIOS:",
            respuesta.status
        );


        console.log(
            "RESPUESTA RAW SALARIOS:",
            texto
        );


        let resultado;


        try {

            resultado =
                texto
                    ? JSON.parse(texto)
                    : {};

        }
        catch (error) {

            throw new Error(
                "El servidor no devolvió JSON en /salario/listar.\n\n" +
                texto.substring(
                    0,
                    500
                )
            );

        }


        if (!respuesta.ok) {

            throw new Error(
                resultado.mensaje ||
                resultado.message ||
                resultado.error ||
                "Error HTTP " +
                respuesta.status
            );

        }


        let lista = [];


        if (
            resultado &&
            Array.isArray(
                resultado.data
            )
        ) {

            lista =
                resultado.data;

        }

        else if (
            resultado &&
            Array.isArray(
                resultado.salarios
            )
        ) {

            lista =
                resultado.salarios;

        }

        else if (
            resultado &&
            Array.isArray(
                resultado.registros
            )
        ) {

            lista =
                resultado.registros;

        }

        else if (
            Array.isArray(
                resultado
            )
        ) {

            lista =
                resultado;

        }


        salarios =
            lista;


        console.log(
            "TOTAL SALARIOS:",
            salarios.length
        );


        renderizarSalarios(
            salarios
        );


        actualizarResumen(
            salarios
        );

    }
    catch (error) {

        console.error(
            "ERROR CARGANDO SALARIOS:",
            error
        );


        salarios = [];


        if (tbody) {

            tbody.innerHTML = `
                <tr>
                    <td
                        colspan="9"
                        class="text-center text-danger py-5">

                        <i
                            class="bi bi-exclamation-triangle fs-1 d-block mb-3">
                        </i>

                        <strong>
                            Error al cargar los salarios
                        </strong>

                        <div class="small mt-2">
                            ${escapeHTML(
                                error.message
                            )}
                        </div>

                    </td>
                </tr>
            `;

        }

    }

}


// ==========================================================
// RENDERIZAR SALARIOS
// ==========================================================

function renderizarSalarios(
    lista
) {

    const tbody =
        document.getElementById(
            "tbodySalarios"
        );


    if (!tbody) {

        return;

    }


    if (
        !Array.isArray(lista) ||
        lista.length === 0
    ) {

        tbody.innerHTML = `
            <tr>
                <td
                    colspan="9"
                    class="empty-state">

                    <i
                        class="bi bi-cash-stack d-block">
                    </i>

                    <strong>
                        No existen salarios registrados
                    </strong>

                    <div>
                        Presione el botón
                        "Nuevo"
                        para registrar uno.
                    </div>

                </td>
            </tr>
        `;

        return;

    }


    tbody.innerHTML = "";


    lista.forEach(
        function (
            salario,
            index
        ) {

            const nombre =
                salario.NOMBREEMPLEADO ??
                salario.nombreEmpleado ??
                salario.nombre ??
                "";


            const puesto =
                salario.NOMBREPUESTO ??
                salario.nombrePuesto ??
                salario.puesto ??
                "";


            const dpi =
                salario.DPI ??
                salario.dpi ??
                "";


            const direccion =
                salario.DIRECCION ??
                salario.direccion ??
                "";


            const salarioBase =
                Number(
                    salario.SALARIOBASE ??
                    salario.salarioBase ??
                    0
                );


            const fecha =
                salario.FECHAREGISTRO ??
                salario.fechaRegistro ??
                salario.FECHA ??
                salario.fecha ??
                "";


            const estado =
                salario.ESTADO ??
                salario.estado ??
                "";


            const idSalario =
                salario.IDSUELDOEMPLEADO ??
                salario.IDSALARIO ??
                salario.idSueldoEmpleado ??
                salario.idSalario ??
                salario.id ??
                "";


            const inicial =
                obtenerInicial(
                    nombre
                );


            const activo =
                String(
                    estado
                ).toUpperCase() === "A";


            const badge =
                activo
                    ?
                    `
                    <span class="badge-activo">

                        <i
                            class="bi bi-check-circle me-1">
                        </i>

                        Activo

                    </span>
                    `
                    :
                    `
                    <span class="badge-inactivo">

                        <i
                            class="bi bi-x-circle me-1">
                        </i>

                        Inactivo

                    </span>
                    `;


            let botones = "";


            if (idSalario) {

                botones += `
                    <button
                        type="button"
                        class="btn btn-sm btn-outline-primary me-1"
                        title="Actualizar sueldo"
                        onclick="abrirEditarSalario('${escapeJS(idSalario)}')">

                        <i
                            class="bi bi-pencil-square">
                        </i>

                    </button>
                `;

            }


            if (
                activo &&
                idSalario
            ) {

                botones += `
                    <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        title="Desactivar salario"
                        onclick="desactivarSalario('${escapeJS(idSalario)}')">

                        <i
                            class="bi bi-trash3">
                        </i>

                    </button>
                `;

            }


            const fila =
                document.createElement(
                    "tr"
                );


            fila.innerHTML = `
                <td>
                    ${index + 1}
                </td>

                <td>

                    <div
                        class="d-flex align-items-center">

                        <span
                            class="employee-avatar">

                            ${escapeHTML(
                                inicial
                            )}

                        </span>

                        <span
                            class="employee-name">

                            ${escapeHTML(
                                nombre
                            )}

                        </span>

                    </div>

                </td>

                <td>
                    ${escapeHTML(
                        puesto
                    )}
                </td>

                <td>
                    ${escapeHTML(
                        dpi
                    )}
                </td>

                <td>
                    ${escapeHTML(
                        direccion
                    )}
                </td>

                <td>

                    <span class="salary">

                        Q ${formatearNumero(
                            salarioBase
                        )}

                    </span>

                </td>

                <td>
                    ${escapeHTML(
                        formatearFecha(
                            fecha
                        )
                    )}
                </td>

                <td>
                    ${badge}
                </td>

                <td class="text-nowrap">
                    ${botones}
                </td>
            `;


            tbody.appendChild(
                fila
            );

        }
    );

}


// ==========================================================
// ABRIR MODAL EDITAR
// ==========================================================

function abrirEditarSalario(
    idSalario
) {

    const id =
        String(
            idSalario
        );


    if (!id) {

        alert(
            "El ID del salario no es válido."
        );

        return;

    }


    const salario =
        salarios.find(
            function (item) {

                const idItem =
                    item.IDSUELDOEMPLEADO ??
                    item.IDSALARIO ??
                    item.idSueldoEmpleado ??
                    item.idSalario ??
                    item.id ??
                    "";


                return String(
                    idItem
                ) === id;

            }
        );


    if (!salario) {

        alert(
            "No se encontró la información del salario."
        );

        return;

    }


    const idEmpleado =
        salario.IDEMPLEADO ??
        salario.idEmpleado ??
        "";


    const nombre =
        salario.NOMBREEMPLEADO ??
        salario.nombreEmpleado ??
        salario.nombre ??
        "";


    const dpi =
        salario.DPI ??
        salario.dpi ??
        "";


    const direccion =
        salario.DIRECCION ??
        salario.direccion ??
        "";


    const puesto =
        salario.NOMBREPUESTO ??
        salario.nombrePuesto ??
        salario.puesto ??
        "";


    const salarioBase =
        salario.SALARIOBASE ??
        salario.salarioBase ??
        0;


    const estado =
        salario.ESTADO ??
        salario.estado ??
        "A";


    const fecha =
        salario.FECHAREGISTRO ??
        salario.fechaRegistro ??
        salario.FECHA ??
        salario.fecha ??
        "";


    establecerValor(
        "actualizarIdSalario",
        id
    );


    establecerValor(
        "actualizarIdSueldo",
        id
    );


    establecerValor(
        "actualizarIdEmpleado",
        idEmpleado
    );


    establecerValor(
        "actualizarNombreEmpleado",
        nombre
    );


    establecerValor(
        "actualizarDpi",
        dpi
    );


    establecerValor(
        "actualizarDireccion",
        direccion
    );


    establecerValor(
        "actualizarPuesto",
        puesto
    );


    establecerValor(
        "actualizarSalarioBase",
        Number(
            salarioBase
        ).toFixed(2)
    );


    establecerValor(
        "actualizarEstado",
        String(
            estado
        ).toUpperCase()
    );


    const fechaInput =
        document.getElementById(
            "actualizarFecha"
        );


    if (fechaInput) {

        fechaInput.value =
            convertirFechaInput(
                fecha
            ) ||
            obtenerFechaHoy();

    }


    const modalElement =
        document.getElementById(
            "modalActualizarSalario"
        );


    if (!modalElement) {

        alert(
            "No existe el modal de actualización."
        );

        return;

    }


    const modal =
        bootstrap.Modal.getOrCreateInstance(
            modalElement
        );


    modal.show();

}


// ==========================================================
// ACTUALIZAR SALARIO
// ==========================================================

async function actualizarSalario() {

    if (actualizandoSalario) {

        return;

    }


    const idSalario =
        obtenerValor(
            "actualizarIdSalario"
        );


    const idEmpleado =
        obtenerValor(
            "actualizarIdEmpleado"
        );


    const salarioBase =
        obtenerValor(
            "actualizarSalarioBase"
        );


    const estado =
        obtenerValor(
            "actualizarEstado"
        );


    const fecha =
        obtenerValor(
            "actualizarFecha"
        );


    const idSalarioNumero =
        parseInt(
            idSalario,
            10
        );


    const idEmpleadoNumero =
        parseInt(
            idEmpleado,
            10
        );


    const salarioNumero =
        parseFloat(
            salarioBase
        );


    if (
        isNaN(idSalarioNumero) ||
        idSalarioNumero <= 0
    ) {

        alert(
            "El ID del salario no es válido."
        );

        return;

    }


    if (
        isNaN(idEmpleadoNumero) ||
        idEmpleadoNumero <= 0
    ) {

        alert(
            "El ID del empleado no es válido."
        );

        return;

    }


    if (
        isNaN(salarioNumero) ||
        salarioNumero <= 0
    ) {

        alert(
            "Debe ingresar un sueldo válido."
        );

        return;

    }


    if (
        estado !== "A" &&
        estado !== "I"
    ) {

        alert(
            "Debe seleccionar un estado válido."
        );

        return;

    }


    if (
        !fecha ||
        !/^\d{4}-\d{2}-\d{2}$/.test(
            fecha
        )
    ) {

        alert(
            "Debe seleccionar una fecha válida."
        );

        return;

    }


    const boton =
        document.getElementById(
            "btnActualizarSalario"
        );


    const textoOriginal =
        boton
            ? boton.innerHTML
            : "";


    actualizandoSalario = true;


    try {

        if (boton) {

            boton.disabled = true;

            boton.innerHTML = `
                <span
                    class="spinner-border spinner-border-sm me-2">
                </span>

                Actualizando...
            `;

        }


        const datos = {

            IDSUELDOEMPLEADO:
                idSalarioNumero,

            IDEMPLEADO:
                idEmpleadoNumero,

            SALARIOBASE:
                salarioNumero,

            FECHAREGISTRO:
                fecha,

            ESTADO:
                estado

        };


        console.log(
            "DATOS ACTUALIZAR:",
            datos
        );


        const respuesta =
            await fetch(
                API_SALARIO_ACTUALIZAR,
                {
                    method: "PUT",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        const texto =
            await respuesta.text();


        console.log(
            "RESPUESTA ACTUALIZAR RAW:",
            texto
        );


        let resultado;


        try {

            resultado =
                texto
                    ? JSON.parse(texto)
                    : {};

        }
        catch (error) {

            throw new Error(
                "Node.js no devolvió JSON al actualizar.\n\n" +
                texto.substring(
                    0,
                    500
                )
            );

        }


        const correcto =
            resultado.success === true ||
            resultado.ok === true;


        if (
            !respuesta.ok ||
            !correcto
        ) {

            throw new Error(
                resultado.mensaje ||
                resultado.message ||
                resultado.error ||
                "No se pudo actualizar el sueldo."
            );

        }


        alert(
            resultado.mensaje ||
            resultado.message ||
            "Sueldo actualizado correctamente."
        );


        cerrarModal(
            "modalActualizarSalario"
        );


        await cargarSalarios();

    }
    catch (error) {

        console.error(
            "ERROR ACTUALIZANDO SALARIO:",
            error
        );


        alert(
            "ERROR AL ACTUALIZAR EL SUELDO:\n\n" +
            error.message
        );

    }
    finally {

        actualizandoSalario = false;


        if (boton) {

            boton.disabled = false;

            boton.innerHTML =
                textoOriginal;

        }

    }

}


// ==========================================================
// GUARDAR SALARIO
// ==========================================================

async function guardarSalario() {

    if (guardandoSalario) {

        return;

    }


    const idEmpleado =
        obtenerValor(
            "idEmpleado"
        );


    const salarioBase =
        obtenerValor(
            "salarioBase"
        );


    const estado =
        obtenerValor(
            "estadoSalario"
        );


    const fecha =
        obtenerValor(
            "fechaSalario"
        );


    const idEmpleadoNumero =
        parseInt(
            idEmpleado,
            10
        );


    const salarioNumero =
        parseFloat(
            salarioBase
        );


    if (
        isNaN(idEmpleadoNumero) ||
        idEmpleadoNumero <= 0
    ) {

        alert(
            "Debe seleccionar un empleado."
        );

        return;

    }


    if (
        isNaN(salarioNumero) ||
        salarioNumero <= 0
    ) {

        alert(
            "Debe ingresar un salario válido."
        );


        const campo =
            document.getElementById(
                "salarioBase"
            );


        if (campo) {

            campo.focus();

        }


        return;

    }


    if (
        estado !== "A" &&
        estado !== "I"
    ) {

        alert(
            "Seleccione un estado válido."
        );

        return;

    }


    if (
        !fecha ||
        !/^\d{4}-\d{2}-\d{2}$/.test(
            fecha
        )
    ) {

        alert(
            "Seleccione una fecha válida."
        );

        return;

    }


    const boton =
        document.getElementById(
            "btnGuardarSalario"
        );


    const textoOriginal =
        boton
            ? boton.innerHTML
            : "";


    guardandoSalario = true;


    try {

        if (boton) {

            boton.disabled = true;

            boton.innerHTML = `
                <span
                    class="spinner-border spinner-border-sm me-2">
                </span>

                Guardando...
            `;

        }


        const datos = {

            IDEMPLEADO:
                idEmpleadoNumero,

            SALARIOBASE:
                salarioNumero,

            FECHAREGISTRO:
                fecha,

            ESTADO:
                estado

        };


        console.log(
            "DATOS INSERTAR:",
            datos
        );


        const respuesta =
            await fetch(
                API_SALARIO_INSERTAR,
                {
                    method: "POST",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        const texto =
            await respuesta.text();


        console.log(
            "RESPUESTA INSERTAR RAW:",
            texto
        );


        let resultado;


        try {

            resultado =
                texto
                    ? JSON.parse(texto)
                    : {};

        }
        catch (error) {

            throw new Error(
                "Node.js no devolvió JSON al guardar.\n\n" +
                texto.substring(
                    0,
                    500
                )
            );

        }


        const correcto =
            resultado.success === true ||
            resultado.ok === true;


        if (
            !respuesta.ok ||
            !correcto
        ) {

            throw new Error(
                resultado.mensaje ||
                resultado.message ||
                resultado.error ||
                "No se pudo guardar el salario."
            );

        }


        alert(
            resultado.mensaje ||
            resultado.message ||
            "Salario registrado correctamente."
        );


        cerrarModal(
            "modalSalario"
        );


        limpiarFormulario();


        await cargarSalarios();

    }
    catch (error) {

        console.error(
            "ERROR GUARDANDO SALARIO:",
            error
        );


        alert(
            "ERROR AL GUARDAR EL SALARIO:\n\n" +
            error.message
        );

    }
    finally {

        guardandoSalario = false;


        if (boton) {

            boton.disabled = false;

            boton.innerHTML =
                textoOriginal;

        }

    }

}


// ==========================================================
// DESACTIVAR SALARIO
// ==========================================================

async function desactivarSalario(
    idSalario
) {

    if (eliminandoSalario) {

        return;

    }


    const id =
        parseInt(
            idSalario,
            10
        );


    if (
        isNaN(id) ||
        id <= 0
    ) {

        alert(
            "El ID del salario no es válido."
        );

        return;

    }


    const confirmar =
        confirm(
            "¿Está seguro de desactivar este salario base?"
        );


    if (!confirmar) {

        return;

    }


    eliminandoSalario = true;


    try {

        console.log(
            "=========================================="
        );

        console.log(
            "DESACTIVANDO SALARIO"
        );

        console.log(
            "RUTA:",
            API_SALARIO_ELIMINAR
        );

        console.log(
            "IDSUELDOEMPLEADO:",
            id
        );

        console.log(
            "MÉTODO: DELETE"
        );

        console.log(
            "=========================================="
        );


        // ==================================================
        // IMPORTANTE
        //
        // LA RUTA DEL BACKEND ES:
        //
        // DELETE /salario/eliminar
        //
        // POR ESO AQUÍ DEBE SER DELETE.
        // ==================================================

        const respuesta =
            await fetch(
                API_SALARIO_ELIMINAR,
                {
                    method: "DELETE",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify({

                            IDSUELDOEMPLEADO:
                                id

                        })

                }
            );


        const texto =
            await respuesta.text();


        console.log(
            "STATUS ELIMINAR:",
            respuesta.status
        );


        console.log(
            "RESPUESTA ELIMINAR RAW:",
            texto
        );


        let resultado;


        try {

            resultado =
                texto
                    ? JSON.parse(texto)
                    : {};

        }
        catch (error) {

            throw new Error(
                "Node.js no devolvió JSON al desactivar.\n\n" +
                texto.substring(
                    0,
                    500
                )
            );

        }


        console.log(
            "RESULTADO ELIMINAR:",
            resultado
        );


        const correcto =
            resultado.success === true ||
            resultado.ok === true;


        if (
            !respuesta.ok ||
            !correcto
        ) {

            throw new Error(
                resultado.mensaje ||
                resultado.message ||
                resultado.error ||
                "No se pudo desactivar el salario."
            );

        }


        // ==================================================
        // MENSAJE
        // ==================================================

        alert(
         
            "ELIMINACION CORRECTA "
        );


        // ==================================================
        // RECARGAR TABLA
        // ==================================================

        await cargarSalarios();


    }
    catch (error) {

        console.error(
            "ERROR DESACTIVANDO SALARIO:",
            error
        );


        alert(
            "ERROR AL DESACTIVAR EL SALARIO:\n\n" +
            error.message
        );

    }
    finally {

        eliminandoSalario = false;

    }

}


// ==========================================================
// LIMPIAR FORMULARIO
// ==========================================================

function limpiarFormulario() {

    const formulario =
        document.getElementById(
            "formSalario"
        );


    if (formulario) {

        formulario.reset();

    }


    const select =
        document.getElementById(
            "idEmpleado"
        );


    if (select) {

        select.value = "";

    }


    const estado =
        document.getElementById(
            "estadoSalario"
        );


    if (estado) {

        estado.value = "A";

    }


    limpiarDatosEmpleado();

    establecerFechaActual();

}


// ==========================================================
// ACTUALIZAR RESUMEN
// ==========================================================

function actualizarResumen(
    lista
) {

    const totalEmpleados =
        document.getElementById(
            "totalEmpleados"
        );


    const totalSalarios =
        document.getElementById(
            "totalSalarios"
        );


    const salarioPromedio =
        document.getElementById(
            "salarioPromedio"
        );


    const activos =
        (lista || []).filter(
            function (item) {

                const estado =
                    item.ESTADO ??
                    item.estado ??
                    "";


                return (
                    String(
                        estado
                    ).toUpperCase() === "A"
                );

            }
        );


    let total = 0;


    activos.forEach(
        function (item) {

            total +=
                Number(
                    item.SALARIOBASE ??
                    item.salarioBase ??
                    0
                );

        }
    );


    const promedio =
        activos.length > 0
            ? total / activos.length
            : 0;


    if (totalEmpleados) {

        totalEmpleados.textContent =
            activos.length;

    }


    if (totalSalarios) {

        totalSalarios.textContent =
            "Q " +
            formatearNumero(
                total
            );

    }


    if (salarioPromedio) {

        salarioPromedio.textContent =
            "Q " +
            formatearNumero(
                promedio
            );

    }

}


// ==========================================================
// FILTRAR SALARIOS
// ==========================================================

function filtrarSalarios(
    texto
) {

    const busqueda =
        String(
            texto || ""
        )
        .toLowerCase()
        .trim();


    if (!busqueda) {

        renderizarSalarios(
            salarios
        );

        return;

    }


    const resultado =
        salarios.filter(
            function (item) {

                const nombre =
                    String(
                        item.NOMBREEMPLEADO ??
                        item.nombreEmpleado ??
                        ""
                    ).toLowerCase();


                const dpi =
                    String(
                        item.DPI ??
                        item.dpi ??
                        ""
                    ).toLowerCase();


                const puesto =
                    String(
                        item.NOMBREPUESTO ??
                        item.nombrePuesto ??
                        ""
                    ).toLowerCase();


                const direccion =
                    String(
                        item.DIRECCION ??
                        item.direccion ??
                        ""
                    ).toLowerCase();


                const salario =
                    String(
                        item.SALARIOBASE ??
                        item.salarioBase ??
                        ""
                    ).toLowerCase();


                return (
                    nombre.includes(
                        busqueda
                    ) ||

                    dpi.includes(
                        busqueda
                    ) ||

                    puesto.includes(
                        busqueda
                    ) ||

                    direccion.includes(
                        busqueda
                    ) ||

                    salario.includes(
                        busqueda
                    )
                );

            }
        );


    renderizarSalarios(
        resultado
    );

}


// ==========================================================
// CONVERTIR FECHA PARA INPUT
// ==========================================================

function convertirFechaInput(
    fecha
) {

    if (!fecha) {

        return "";

    }


    const texto =
        String(
            fecha
        );


    // YYYY-MM-DD

    if (
        /^\d{4}-\d{2}-\d{2}/.test(
            texto
        )
    ) {

        return texto.substring(
            0,
            10
        );

    }


    // DD/MM/YYYY

    if (
        /^\d{2}\/\d{2}\/\d{4}$/.test(
            texto
        )
    ) {

        const partes =
            texto.split("/");


        return (
            partes[2] +
            "-" +
            partes[1] +
            "-" +
            partes[0]
        );

    }


    const fechaObj =
        new Date(
            fecha
        );


    if (
        isNaN(
            fechaObj.getTime()
        )
    ) {

        return "";

    }


    return (
        fechaObj.getFullYear() +
        "-" +
        String(
            fechaObj.getMonth() + 1
        ).padStart(
            2,
            "0"
        ) +
        "-" +
        String(
            fechaObj.getDate()
        ).padStart(
            2,
            "0"
        )
    );

}


// ==========================================================
// FECHA DE HOY
// ==========================================================

function obtenerFechaHoy() {

    const hoy =
        new Date();


    return (
        hoy.getFullYear() +
        "-" +
        String(
            hoy.getMonth() + 1
        ).padStart(
            2,
            "0"
        ) +
        "-" +
        String(
            hoy.getDate()
        ).padStart(
            2,
            "0"
        )
    );

}


// ==========================================================
// FORMATEAR FECHA
// ==========================================================

function formatearFecha(
    fecha
) {

    if (!fecha) {

        return "";

    }


    const texto =
        String(
            fecha
        );


    // YYYY-MM-DD

    if (
        /^\d{4}-\d{2}-\d{2}/.test(
            texto
        )
    ) {

        const partes =
            texto
                .substring(
                    0,
                    10
                )
                .split("-");


        return (
            partes[2] +
            "/" +
            partes[1] +
            "/" +
            partes[0]
        );

    }


    // DD/MM/YYYY

    if (
        /^\d{2}\/\d{2}\/\d{4}$/.test(
            texto
        )
    ) {

        return texto;

    }


    const fechaObj =
        new Date(
            fecha
        );


    if (
        isNaN(
            fechaObj.getTime()
        )
    ) {

        return texto;

    }


    return (
        String(
            fechaObj.getDate()
        ).padStart(
            2,
            "0"
        ) +
        "/" +
        String(
            fechaObj.getMonth() + 1
        ).padStart(
            2,
            "0"
        ) +
        "/" +
        fechaObj.getFullYear()
    );

}


// ==========================================================
// OBTENER INICIAL
// ==========================================================

function obtenerInicial(
    nombre
) {

    if (!nombre) {

        return "?";

    }


    return String(
        nombre
    )
    .trim()
    .charAt(0)
    .toUpperCase();

}


// ==========================================================
// FORMATEAR NUMERO
// ==========================================================

function formatearNumero(
    numero
) {

    return Number(
        numero || 0
    )
    .toLocaleString(
        "es-GT",
        {
            minimumFractionDigits:
                2,

            maximumFractionDigits:
                2
        }
    );

}


// ==========================================================
// OBTENER VALOR
// ==========================================================

function obtenerValor(
    id
) {

    const elemento =
        document.getElementById(
            id
        );


    if (!elemento) {

        return "";

    }


    return elemento.value;

}


// ==========================================================
// ESTABLECER VALOR
// ==========================================================

function establecerValor(
    id,
    valor
) {

    const elemento =
        document.getElementById(
            id
        );


    if (elemento) {

        elemento.value =
            valor ?? "";

    }

}


// ==========================================================
// CERRAR MODAL
// ==========================================================

function cerrarModal(
    id
) {

    const elemento =
        document.getElementById(
            id
        );


    if (!elemento) {

        return;

    }


    const modal =
        bootstrap.Modal.getInstance(
            elemento
        );


    if (modal) {

        modal.hide();

    }

}


// ==========================================================
// ESCAPAR HTML
// ==========================================================

function escapeHTML(
    valor
) {

    return String(
        valor ?? ""
    )
    .replace(
        /&/g,
        "&amp;"
    )
    .replace(
        /</g,
        "&lt;"
    )
    .replace(
        />/g,
        "&gt;"
    )
    .replace(
        /"/g,
        "&quot;"
    )
    .replace(
        /'/g,
        "&#039;"
    );

}


// ==========================================================
// ESCAPAR JAVASCRIPT
// ==========================================================

function escapeJS(
    valor
) {

    return String(
        valor ?? ""
    )
    .replace(
        /\\/g,
        "\\\\"
    )
    .replace(
        /'/g,
        "\\'"
    )
    .replace(
        /\n/g,
        "\\n"
    )
    .replace(
        /\r/g,
        "\\r"
    );

}


// ==========================================================
// EXPONER FUNCIONES PARA LOS BOTONES
// ==========================================================

window.abrirEditarSalario =
    abrirEditarSalario;


window.desactivarSalario =
    desactivarSalario;